export function locationsScroll() {
    const locationsAmount = $('.location-item').length;
    jcf.destroyAll();
    jcf.refreshAll();

    if (locationsAmount > 1 && ($("body").hasClass("no-touch") && window.innerWidth > 1199)) {
        jcf.replaceAll();
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/locationsScroll.js